import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import './PromotionalBanner.css';

const PromotionalBanner = ({ items = [], onItemClick, highlightedDrinkId }) => {
    // Default promotional items if none provided
    const defaultItems = [
        { name: 'Mojito', oldPrice: '12.00', newPrice: '9.00', discount: '25%' },
        { name: 'Margarita', oldPrice: '14.00', newPrice: '11.00', discount: '20%' },
        { name: 'Whiskey Sour', oldPrice: '16.00', newPrice: '12.00', discount: '25%' },
        { name: 'Espresso', oldPrice: '4.00', newPrice: '3.00', discount: '25%' },
        { name: 'Cappuccino', oldPrice: '5.00', newPrice: '4.00', discount: '20%' },
    ];

    const promotionalItems = items.length > 0 ? items : defaultItems;

    // Duplicate items 10 times for completely seamless infinite scroll
    const duplicatedItems = [
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
        ...promotionalItems,
    ];

    return (
        <Box className="promotional-banner">
            <Box className="banner-content">
                <Box className="scrolling-wrapper">
                    <Box className="scrolling-items">
                        {duplicatedItems.map((item, index) => (
                            <Box
                                key={index}
                                className={`promo-item ${highlightedDrinkId && item.drink_id === highlightedDrinkId ? 'highlighted' : ''}`}
                                onClick={() => onItemClick && onItemClick(item)}
                                sx={{ cursor: onItemClick ? 'pointer' : 'default' }}
                            >
                                <LocalOfferIcon className="promo-icon" />
                                <Typography className="promo-text">
                                    <span className="item-name">{item.name}</span>
                                    <span className="price-container">
                                        <span className="old-price">{item.oldPrice}€</span>
                                        <span className="arrow">→</span>
                                        <span className="new-price">{item.newPrice}€</span>
                                    </span>
                                </Typography>
                                <Chip
                                    label={`-${item.discount}`}
                                    size="small"
                                    className="discount-chip"
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default PromotionalBanner;
